module.exports = __webpack_public_path__ + "img/slc.f3fbf2e0.jpg";